import React from 'react'
import styled, { keyframes } from 'styled-components'
import ktaxaLogo from '!url-loader!assets/images/logo-ktaxa-th-bordered.png'

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: ${spin} 1s linear infinite;
`

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

const Image = styled.img`
  width: 100px; /* กำหนดขนาดของรูปภาพด้านบน */
  margin-bottom: 20px; /* เพิ่มระยะห่างระหว่างรูปภาพกับ spinner */
`

const LoadingSpinner = () => (
  <LoadingContainer>
    <Image src={ktaxaLogo} alt="Your Image" />
    <Spinner />
  </LoadingContainer>
)

export default LoadingSpinner
